import { createContext, useContext } from 'react'

export const NotificationContext = createContext()

export const useNotificationContext = () => {
  const context = useContext(NotificationContext)

  if (!context) {
    throw new Error('useNotificationContext must be used within a UserContext')
  }
  return context
}
